import { NON_PRE_DRAFT_SUBMISSION_STATUSES, ResourceState } from '@domain/schemas/contract.schema';
import { StatusBadge } from '@pages/User/components';
import { getFormattedStatus } from '@root/helpers/resources';
import type { CellContext, ColumnHelper } from '@tanstack/react-table';

const getAvailableStatuses = (hasFirmOrderStatus: boolean) => {
  if (!hasFirmOrderStatus) {
    return NON_PRE_DRAFT_SUBMISSION_STATUSES.filter((status) => status !== 'FIRM_ORDER');
  }

  return NON_PRE_DRAFT_SUBMISSION_STATUSES;
};

export const statusAccessor = <T extends { status?: string }>(
  columnHelper: ColumnHelper<T>,
  hasFirmOrderStatus: boolean = false,
  hasPreDrafts: boolean = false,
) => {
  const statuses = getAvailableStatuses(hasFirmOrderStatus);

  return columnHelper.accessor((entity) => entity.status, {
    id: 'status',
    header: 'Status',
    filterFn: 'arrIncludesSome',
    cell: (cellContext: CellContext<T, ResourceState>) => <StatusBadge status={cellContext.getValue()} />,
    meta: {
      filter: {
        placeholder: 'All statuses',
        selected: statuses.filter((status) => status !== 'ARCHIVED'),
        options: (hasPreDrafts ? [...statuses, ResourceState.PRE_DRAFT] : statuses).map((status) => ({
          name: getFormattedStatus(status),
          value: status,
        })),
      },
      dataCellClassName: 'px-3 py-1',
    },
  });
};
